import Button from '@/components/base/button/button';
import { useRouter } from '@/navigation';
import { BASKET_ROUTES } from '@/routes';
import {
  type FlyBasketStore,
  useFlyBasketStore,
} from '@/store/fly-basket-store';
import { useTranslations } from 'next-intl';

const selector = ({ close }: FlyBasketStore) => ({
  close,
});

export const ActionButtons = () => {
  const router = useRouter();
  const t = useTranslations('navigation.fly_basket');
  const { close } = useFlyBasketStore(selector);

  const redirectToBasket = () => {
    router.push(BASKET_ROUTES.MAIN);
    close();
  };

  const redirectToBuy = () => {
    router.push(BASKET_ROUTES.CHECKOUT);
    close();
  };

  return (
    <div className="flex s:flex-row flex-col gap-xxs xs:gap-xs no-flex-gap:s:space-x-xs no-flex-gap:s:space-y-0 no-flex-gap:space-y-xxs no-flex-gap:xs:space-y-xs">
      <Button
        variant="primary"
        accented
        className="s:flex-[2]"
        onClick={redirectToBuy}
        testId="buy-now-button"
      >
        {t('buy_now_btn')}
      </Button>
      <Button
        variant="secondary"
        onClick={redirectToBasket}
        testId="view-basket-button"
      >
        {t('view_basket_btn')}
      </Button>
    </div>
  );
};
